import { useState } from 'react'

interface FaqItem {
  question: string
  answer: string
  category: 'general' | 'community' | 'events'
}

const faqs: FaqItem[] = [
  {
    question: 'Jak se mohu připojit k Allcom?',
    answer: 'Stačí kliknout na tlačítko "Vstoupit na Discord" nebo použít náš Discord invite link. Po připojení si přečtěte pravidla a vyberte si role podle vašich zájmů.',
    category: 'general'
  },
  {
    question: 'Je připojení zdarma?',
    answer: 'Ano, členství v Allcom je zcela zdarma. Všechny naše akce a aktivity jsou přístupné všem členům bez poplatků.',
    category: 'general'
  },
  {
    question: 'Jaké hry hrajete?',
    answer: 'Hrajeme širokou škálu her - od populárních titulů jako Delta Force, R.E.P.O, Phasmophobia, až po indie hry a party games. Každý si najde to své!',
    category: 'community'
  },
  {
    question: 'Musím se účastnit všech akcí?',
    answer: 'Ne, účast na akcích je dobrovolná. Připojte se, když máte čas a chuť. Každý je vítán podle svých možností.',
    category: 'events'
  },
  {
    question: 'Jaká jsou pravidla komunity?',
    answer: 'Hlavní pravidla: respekt k ostatním, žádná vulgarita, žádné toxické chování. Kompletní pravidla najdete na našem Discord serveru.',
    category: 'community'
  },
  {
    question: 'Jak se mohu zapojit do organizace akcí?',
    answer: 'Rádi přivítáme nové organizátory! Kontaktujte moderátory nebo vedení Evobugu na Discordu a domluvte se na detailech.',
    category: 'events'
  },
]


const categories = [
  { id: 'all', label: 'Vše' },
  { id: 'general', label: 'Obecné' },
  { id: 'community', label: 'Komunita' },
  { id: 'events', label: 'Akce' },
] as const

function FaqSection() {
  const [category, setCategory] = useState<'all' | FaqItem['category']>('all')
  const visible = category === 'all' ? faqs : faqs.filter((faq) => faq.category === category)
  return (
    <section id="faq" className="ac-section ac-width ac-faq">
      <div className="ac-section-lead">
        <h2>Ještě něco<br />než se přidáš.</h2>
        <div>
          <p>Časté otázky o Allcomu.</p>
          <a href="https://discord.allcom.zone" className="ac-text-link" target="_blank" rel="noopener noreferrer">Zeptej se nás na Discordu</a>
        </div>
      </div>
      <div className="ac-faq-categories" role="group" aria-label="Kategorie otázek">
        {categories.map((item) => <button type="button" key={item.id} aria-pressed={category === item.id} onClick={() => setCategory(item.id)}>{item.label}</button>)}
      </div>
      <div className="ac-faq-list">
        {visible.map((faq) => <details key={faq.question}><summary>{faq.question}</summary><p>{faq.answer}</p></details>)}
      </div>
    </section>
  )
}

export default FaqSection
